<form role="form" [formGroup]="form" novalidate>
  <div class="box-body">
    <mat-stepper linear #stepper (selectionChange)="onStepChange($event)">
      <mat-step label="Details" [stepControl]="detailsStepForm">
        <div class="form-group col-sm-6 col-xs-12">
          <label for="title">Name of parking place*</label>
          <input type="text" class="form-control" formControlName="title" placeholder="Enter the name">
          @if (form.controls['title'].hasError('required') && (secondStepAttempt || form.controls['title'].touched)) {
          <control-message message="Parking name is required."></control-message>
          }
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="title_ar">Name of parking place (arabic)*</label>
          <input type="text" class="form-control" formControlName="title_ar" placeholder="Enter the name">
          @if (form.controls['title_ar'].hasError('required') && (secondStepAttempt ||
          form.controls['title_ar'].touched)) {
          <control-message message="Parking name (arabic) is required."></control-message>
          }
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="capacity">Capacity*</label>
          <input type="number" class="form-control" formControlName="capacity" placeholder="Capacity">
          @if (form.controls['capacity'].hasError('required') && (secondStepAttempt ||
          form.controls['capacity'].touched)) {
          <control-message message="Capacity is required."></control-message>
          }
          @if (form.controls['capacity'].hasError('pattern') && (secondStepAttempt ||
          form.controls['capacity'].touched)) {
          <control-message message="Capacity must be a number."></control-message>
          }
        </div>
        <div class="form-group col-sm-6 col-xs-12">
          <label for="counter">Counter*</label>
          <input type="number" class="form-control" formControlName="counter" placeholder="counter">
          @if (form.controls['counter'].hasError('required') && (secondStepAttempt || form.controls['counter'].touched))
          {
          <control-message message="counter is required."></control-message>
          }
          @if (form.controls['counter'].hasError('pattern') && (secondStepAttempt || form.controls['counter'].touched))
          {
          <control-message message="counter must be a number."></control-message>
          }
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="vat_percentage">Vat percentage*</label>
          <input type="number" class="form-control" formControlName="vat_percentage" placeholder="Vat Percentage">
          @if (form.controls['vat_percentage'].hasError('required') && (secondStepAttempt ||
          form.controls['vat_percentage'].touched)) {
          <control-message message="Vat percentage is required."></control-message>
          }
          <!-- <control-message
          *ngIf="form.controls['vat_percentage'].hasError('pattern') && (secondStepAttempt || form.controls['vat_percentage'].touched)"
        message="Vat percentage must be a number."></control-message> -->
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="discount_percentage">Discount percentage*</label>
          <input type="number" class="form-control" formControlName="discount_percentage"
            placeholder="Discount Percentage">
          @if (form.controls['discount_percentage'].hasError('required') && (secondStepAttempt ||
          form.controls['discount_percentage'].touched)) {
          <control-message message="Discount percentage is required."></control-message>
          }
          <!-- <control-message
        *ngIf="form.controls['discount_percentage'].hasError('pattern') && (secondStepAttempt || form.controls['discount_percentage'].touched)"
      message="Discount percentage must be a number."></control-message> -->
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="service_charge">Service Charge*</label>
          <input type="number" class="form-control" formControlName="service_charge" placeholder="Service Charge">
          @if (form.controls['service_charge'].hasError('required') && (secondStepAttempt ||
          form.controls['service_charge'].touched)) {
          <control-message message="Service Charge is required."></control-message>
          }
          <!-- <control-message
      *ngIf="form.controls['service_charge'].hasError('pattern') && (secondStepAttempt || form.controls['service_charge'].touched)"
    message="Service Charge must be a number."></control-message> -->
        </div>
        <div class="form-group col-sm-6 col-xs-12">
          <label for="processing_fee">Processing Fee*</label>
          <input type="number" class="form-control" formControlName="processing_fee" placeholder="Processing Fee">
          @if (form.controls['processing_fee'].hasError('required') && (secondStepAttempt ||
          form.controls['processing_fee'].touched)) {
          <control-message message="Processing Fee is required."></control-message>
          }
          <!-- <control-message
    *ngIf="form.controls['processing_fee'].hasError('pattern') && (secondStepAttempt || form.controls['processing_fee'].touched)"
  message="Processing Fee must be a number."></control-message> -->
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="support_email">Support Email*</label>
          <input type="text" class="form-control" formControlName="support_email" placeholder="Support Email">
          @if (form.controls['support_email'].hasError('required') && (secondStepAttempt ||
          form.controls['support_email'].touched)) {
          <control-message message="Support Email is required."></control-message>
          }
          <!-- <control-message
  *ngIf="form.controls['support_email'].hasError('pattern') && (secondStepAttempt || form.controls['support_email'].touched)"
message="Support Email must be a number."></control-message> -->
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="currency">Currency*</label>
          <select class="form-control" formControlName="currency" (change)="onCurrencyChange($event.target.value)">
            <option value="">Select Currency</option>
            @for (option of currency_options; track option) {
            <option [value]="option.value">
              {{option.label}}
            </option>
            }
          </select>
          @if (form.controls['currency'].hasError('required') && (secondStepAttempt ||
          form.controls['currency'].touched)) {
          <control-message message="Currency is required.">
          </control-message>
          }
        </div>

        <div class="form-group col-sm-6 col-xs-12">
          <label for="currency_ar">Currency (Arabic)*</label>
          <select class="form-control" formControlName="currency_ar">
            <option value="">Select Currency</option>
            @for (option of currency_options_ar; track option) {
            <option [value]="option.value">
              {{option.label}}
            </option>
            }
          </select>
          @if (form.controls['currency_ar'].hasError('required') && (secondStepAttempt ||
          form.controls['currency_ar'].touched)) {
          <control-message message="Currency (Arabic) is required.">
          </control-message>
          }
        </div>

        <div class="box-footer col-12">
          <button mat-raised-button color="primary" type="button" (click)="validateDetailsStep() && stepper.next()">
            Next Step
          </button>
        </div>
      </mat-step>

      <mat-step label="Location" [stepControl]="locationStepForm">
        <div class="col-sm-12 col-xs-12">
          <div class="col-sm-6 col-xs-12">
            <div class="form-group col-sm-6 col-xs-12">
              <label>Area*</label>
              <input type="text" class="form-control" #search formControlName="area" placeholder="Area"
                (keyup)="onAreaChange($event)">
              @if (form.controls['area'].hasError('required') && (thirdStepAttempt || form.controls['area'].touched))
              {
              <control-message message="Area is required."></control-message>
              }
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label>Area (arabic)*</label>
              <input type="text" class="form-control" formControlName="area_ar" placeholder="Area (arabic)">
              @if (form.controls['area_ar'].hasError('required') && (thirdStepAttempt ||
              form.controls['area_ar'].touched)) {
              <control-message message="Area (arabic) is required."></control-message>
              }
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label for="city">City</label>
              <input type="text" class="form-control" formControlName="city" placeholder="City">
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label for="city_ar">City (arabic)</label>
              <input type="text" class="form-control" formControlName="city_ar" placeholder="City (arabic)">
            </div>

            <div class="form-group col-sm-6 col-xs-12">
              <label for="country">Country*</label>
              <input type="text" class="form-control" formControlName="country" placeholder="Country">
              @if (form.controls['country'].hasError('required') && (thirdStepAttempt ||
              form.controls['country'].touched)) {
              <control-message message="Country is required."></control-message>
              }
            </div>

            <div class="form-group col-sm-6 col-xs-12">
              <label for="country_ar">Country (arabic)*</label>
              <input type="text" class="form-control" formControlName="country_ar" placeholder="Country (arabic)">
              @if (form.controls['country_ar'].hasError('required') && (thirdStepAttempt ||
              form.controls['country_ar'].touched)) {
              <control-message message="Country (arabic) is required."></control-message>
              }
            </div>

            <div class="form-group col-sm-6 col-xs-12">
              <label for="Latitude">Latitude*</label>
              <input type="text" class="form-control" formControlName="Latitude" placeholder="Latitude">
              @if (form.controls['Latitude'].hasError('required') && (thirdStepAttempt ||
              form.controls['Latitude'].touched)) {
              <control-message message="Latitude is required."></control-message>
              }
            </div>

            <div class="form-group col-sm-6 col-xs-12">
              <label for="longitude">Longitude*</label>
              <input type="text" class="form-control" formControlName="longitude" placeholder="Longitude">
              @if (form.controls['longitude'].hasError('required') && (thirdStepAttempt ||
              form.controls['longitude'].touched)) {
              <control-message message="Longitude is required."></control-message>
              }
            </div>

          </div>

          <div class="col-sm-6 col-xs-12">
            <google-map height="400px" width="100%" [center]="{ lat: Latitude, lng: longitude }" [zoom]="zoom"
              (mapClick)="onMapClick($event)">

              <map-marker [position]="{ lat: Latitude, lng: longitude }" [options]="{ draggable: draggable }"
                (mapDragend)="markerDragEndAddress($event)">
              </map-marker>

            </google-map>
          </div>

        </div>

        <div class="clearfix"></div>

        <div class="box-footer">
          <button mat-button type="button" (click)="stepper.previous()">
            Previous Step
          </button>
          <button mat-raised-button color="primary" type="button" matStepperNext (click)="validateLocationStep()">
            Next Step
          </button>
        </div>
      </mat-step>

      <mat-step label="Payment details" [stepControl]="paymentStepForm">
        <div formArrayName="valet_charge_stack">
          <div class="col-sm-12 col-xs-12 form-array">
            <h3 class="md-headline">Charging Stack*</h3>
            <div class="p-4 d-flex align-items-center">
              <form class="d-flex gap-2 align-items-center" [formGroup]="allDaysForm">
                <label class="m-0" for="">All Days of week</label>
                <input formControlName="allDays" type="checkbox">
              </form>

            </div>
            @for (stack of valet_charge_stack.controls; track stack; let i = $index) {
            <div class="d-flex gap-3" [formGroupName]="i" style="display: flex; flex-direction: row;">
              <div class="form-group d-flex flex-column">
                <label for="charge_stack_category">Category</label>
                <select (change)="categoryChanged(i)" class="flex-grow-1 form-control"
                  formControlName="charge_stack_category">
                  @for (item of stack_category; track item) {
                  <option [value]="item.id">{{item.name}}</option>
                  }
                </select>
                @if ((stack.get('charge_stack_category').hasError('required') &&
                stack.get('charge_stack_category').enabled) && (stack.get('charge_stack_category').touched ||
                isSubmitted)) {
                <control-message message='This field is required'></control-message>
                }
              </div>
              @if (stack.controls['day_of_week']) {
              <div class="form-group d-flex flex-column" style="margin-left: 2px;">
                <label for="day_of_week">Day</label>
                <select class="flex-grow-1 form-control" formControlName="day_of_week">
                  @for (item of daysof_week; track item) {
                  <option [value]="item.id">{{item.name}}</option>
                  }
                </select>
                @if ((stack.get('day_of_week').hasError('required') && stack.get('day_of_week').enabled) &&
                (stack.get('day_of_week').touched || isSubmitted)) {
                <control-message message='This field is required'></control-message>
                }
              </div>
              }
              @if (stack.controls['grace_period']) {
              <div class="form-group" style="margin-left: 2px;">
                <label for="grace_period">Grace Period</label>
                <input type="number" min="0" class="form-control" formControlName="grace_period">
                @if ((stack.get('grace_period').hasError('required') && stack.get('grace_period').enabled) &&
                (stack.get('grace_period').touched || isSubmitted)) {
                <control-message message='This field is required'></control-message>
                }
                @if ((stack.get('grace_period').hasError('min') && stack.get('grace_period').enabled) &&
                (stack.get('grace_period').touched || isSubmitted)) {
                <control-message message='Invalid Value'></control-message>
                }
              </div>
              }
              @if (stack.controls['per_hour_charge']) {
              <div class="form-group" style="margin-left: 2px;">
                <label for="per_hour_charge">Hourly Charges</label>
                <input type="number" min="0" class="form-control" formControlName="per_hour_charge">
                @if ((stack.get('per_hour_charge').hasError('required') && stack.get('per_hour_charge').enabled) &&
                (stack.get('per_hour_charge').touched || isSubmitted)) {
                <control-message message="This field is required"></control-message>
                }
                @if ((stack.get('per_hour_charge').hasError('min') && stack.get('per_hour_charge').enabled) &&
                (stack.get('per_hour_charge').touched || isSubmitted)) {
                <control-message message="Invalid Value"></control-message>
                }
              </div>
              }
              @if (stack.controls['per_visit_charge']) {
              <div class="form-group" style="margin-left: 2px;">
                <label for="per_visit_charge">Visit charges</label>
                <input type="number" min="0" class="form-control" formControlName="per_visit_charge">
                @if ((stack.get('per_visit_charge').hasError('required') && stack.get('per_visit_charge').enabled)
                &&
                (stack.get('per_visit_charge').touched || isSubmitted)) {
                <control-message message="This field is required"></control-message>
                }
                @if ((stack.get('per_visit_charge').hasError('min') && stack.get('per_visit_charge').enabled) &&
                (stack.get('per_visit_charge').touched || isSubmitted)) {
                <control-message message="Invalid value"></control-message>
                }
              </div>
              }
              @if (stack.controls['from_min']) {
              <div class="form-group" style="margin-left: 2px;">
                <label for="from_min">From Minutes</label>
                <input type="number" min="0" class="form-control" formControlName="from_min">
                @if ((stack.get('from_min').hasError('required') && stack.get('from_min').enabled) &&
                (stack.get('from_min').touched || isSubmitted)) {
                <control-message message="This field is required"></control-message>
                }
                @if ((stack.get('from_min').hasError('min') && stack.get('from_min').enabled) &&
                (stack.get('from_min').touched || isSubmitted)) {
                <control-message message="Invalid Value"></control-message>
                }
              </div>
              }
              @if (stack.controls['to_min']) {
              <div class="form-group" style="margin-left: 2px;">
                <label for="to_min">To Minutes</label>
                <input type="number" min="0" class="form-control" formControlName="to_min">
                @if ((stack.get('to_min').hasError('required') && stack.get('to_min').enabled) &&
                (stack.get('to_min').touched || isSubmitted)) {
                <control-message message="This field is required"></control-message>
                }
                @if ((stack.get('to_min').hasError('min') && stack.get('to_min').enabled) &&
                (stack.get('to_min').touched || isSubmitted)) {
                <control-message message="Invalid value"></control-message>
                }
              </div>
              }
              @if (stack.controls['flexible_hour_charge']) {
              <div class="form-group" style="margin-left: 2px;">
                <label for="charge">Charge</label>
                <input type="number" min="0" class="form-control" formControlName="flexible_hour_charge">
                @if ((stack.get('flexible_hour_charge').hasError('required') &&
                stack.get('flexible_hour_charge').enabled) && (stack.get('flexible_hour_charge').touched ||
                isSubmitted)) {
                <control-message message="This field is required"></control-message>
                }
                @if ((stack.get('flexible_hour_charge').hasError('min') &&
                stack.get('flexible_hour_charge').enabled)
                &&
                (stack.get('flexible_hour_charge').touched || isSubmitted)) {
                <control-message message="Invalid value"></control-message>
                }
              </div>
              }
              @if (stack.controls['additional_hour_charge']) {
              <div class="form-group" style="margin-left: 2px;">
                <label for="additional_hour_charge">Extra Hr Charge </label>
                <input type="number" min="0" class="form-control" formControlName="additional_hour_charge">
                @if ((stack.get('additional_hour_charge').hasError('required') &&
                stack.get('additional_hour_charge').enabled) && (stack.get('additional_hour_charge').touched ||
                isSubmitted)) {
                <control-message message="This field is required"></control-message>
                }
                @if ((stack.get('additional_hour_charge').hasError('min') &&
                stack.get('additional_hour_charge').enabled) && (stack.get('additional_hour_charge').touched ||
                isSubmitted)) {
                <control-message message="Invalid value"></control-message>
                }
              </div>
              }
            </div>
            }

          </div>
        </div>

        <div class="clearfix"></div>

        <div class="box-footer">
          <button mat-button type="button" (click)="stepper.previous()">
            Previous Step
          </button>
          <button type="button" class="btn btn-success pull-right" (click)="saveParkingPlace()">Submit</button>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
  <!-- /.box-body -->
</form>